module.exports = __webpack_public_path__ + "img/member-icon2-03.362c9629.png";